import styled from "styled-components";

export const Wrapper = styled.div`
	width: 100%;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: flex-start;
	flex-direction: column;
	padding-left: 30px;
	padding-right: 30px;
	padding-top: 30px;
	font-feature-settings: "clig" off, "liga" off;
	font-family: var(--general-font-family);
	max-height: 500px;
	overflow-y: auto;
	@media (max-width: 600px) {
		padding-left: 16px;
		padding-right: 16px;
		padding-top: 16px;
		max-height: none;
	}
`;
export const SummaryTitle = styled.h3`
	color: var(--font-color-blue002e5c);
	font-size: var(--general-header-font-size);
	font-style: normal;
	font-weight: var(--general-header-font-weight);
	line-height: 32px;
	text-align: left;
	padding-bottom: 8px;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	span {
		padding-right: 8px;
	}
`;
export const DataNotFoundWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	background: #f8f8f9;
	width: 100%;
	height: 104px;
	border-top: 1px solid rgba(0, 46, 92, 0.1);
	border-bottom: 1px solid rgba(0, 46, 92, 0.1);

	span {
		color: var(--font-color-grayb5b5c3);
		font-size: var(--general-large-body-font-size);
		font-style: normal;
		font-weight: var(--general-large-body-font-weight);
		line-height: 150%;
	}
`;

export const DataFoundWrapper = styled.div`
	width: 100%;
	max-height: 500px;
`;
export const NumberOfSelections = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 37.96px;
	color: var(--font-color-blue70a0ee);
	background: #eaeefc;
	border-bottom: 1px solid rgba(0, 46, 92, 0.1);
	margin-bottom: 29px;
	@media (max-width: 600px) {
		margin-bottom: 8px;
	}
	span {
		padding-top: 6px;
		padding-bottom: 6px;
	}
`;
export const SummaryItem = styled.div`
	margin-bottom: 24px;
	@media (max-width: 600px) {
		margin-bottom: 14px;
	}
`;

export const SummaryItemCharge = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
`;

export const SummaryItemInfo = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	flex-direction: column;
`;

export const SummaryItemLedger = styled.span`
	color: var(--font-color-blue002e5c);
	font-size: var(--general-amount-font-size);
	font-weight: var(--general-amount-font-weight);
	line-height: 13px;
`;
export const SummaryItemSubLedger = styled.p`
	color: var(--font-color-blue5b7792);
	font-size: var(--general-amount-font-size);
	margin: 0;
	margin-top: 5px;
`;

export const PaymentAmount = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
`;
export const TotalPayment = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: var(--font-color-blue002e5c);
	border-top: 1px dashed rgba(0, 46, 92, 0.1);
	padding-top: 24px;
	padding-bottom: 5px;
	min-height: 100px;
	@media (max-width: 600px) {
		min-height: unset;
		padding-top: 14px;
	}
	p {
		font-size: var(--general-amount-font-size);
		font-weight: var(--general-amount-font-weight);
		line-height: 13px;
		margin-bottom: 0;
	}
	span {
		font-size: var(--general-large-amount-font-size);
		font-style: normal;
		font-weight: var(--general-large-amount-font-weight);
		line-height: 13px;
	}
`;
export const TotalPaymentLeftSide = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 10px;
`;
export const TotalPaymentField = styled.div`
	position: relative;
	width: 150px;

	label {
		margin: 0;
	}
	input {
		font-size: var(--general-xlarge-body-font-size) !important;
	}
`;

export const TotalPaymentFieldSign = styled.span`
	position: absolute;
	left: 5px;
	top: 50%;
	transform: translateY(-50%);
`;
export const TotalPaymentEditIcon = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
`;

export const TotalPaymentEditBtn = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	cursor: pointer;
`;

export const SummaryItemLeft = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	width: 50%;
`;

export const PaymentInstallmentWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
    align-items: end;
    margin-top: 15px;
`;

export const PaymentInstallmentCheckbox = styled.div`
	width: fit-content;
`;
export const PaymentInstallmentSelection = styled.div`
`;

export const PaymentInstallmentLeft = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	width: 50%;
`

export const PaymentInstallmentAmount = styled.div`
    color: var(--font-color-blue5b7792);
    margin-bottom: 12px;
`;

export const TotalDueAmount = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: var(--font-color-blue002e5c);
	padding-top: 5px;
	padding-bottom: 24px;
	@media (max-width: 600px) {
		padding-bottom: 12px;
	}
	p {
		font-size: var(--general-amount-font-size);
		font-weight: var(--general-amount-font-weight);
		line-height: 13px;
		margin-bottom: 0;
	}
	span {
		font-size: var(--general-large-amount-font-size);
		font-style: normal;
		font-weight: var(--general-large-amount-font-weight);
		line-height: 13px;
	}
`